// extracted by mini-css-extract-plugin
export default {"wrapper":"field-label_wrapper__s0Yu8","label":"field-label_label__I4QCy","asterisk":"field-label_asterisk__KwYXD"};